export default {
    '.hide-element-try-on, .hide-element-360': {
        display: 'none !important'
    },
    '.control-icon': {
        opacity: '0.6 !important'
    },
    '.swiper-slide-zoomed img:not(.control-icon)': {
        transform: 'translate3d(0px, 0px, 0px) scale(2) !important'
    },
    '.swiper-slide-zoomed img.control-icon': {
        transform: 'scale(1) !important'
    },
    '.size-guide-header.static': {
        boxShadow: 'var(--chakra-colors-sizeGuideShadow) !important'
    },
    '.mz-button-grid:empty': {
        display: 'none !important'
    },
    '.mirelz-modal-360 .mz-add-to-bag-disable .mz-add-to-bag, .mz-ar-wrapper .mz-add-to-bag-disable':
        {
            backgroundColor: 'gray.40 !important',
            color: 'gray.650 !important',
            opacity: '1 !important'
        },
    '#reviews_container section': {
        overflow: 'hidden'
    },
    '.engraved-img img': {
        mixBlendMode: 'multiply'
    },
    '.span-one': {
        gridColumn: 'span 1 !important'
    },
    '.span-two': {
        gridColumn: 'span 2 !important'
    },
    '.engraving-first-line-wrapper, .engraving-second-line-wrapper, .engraving-third-line-wrapper, .engraving-fonts, .ks-icons-list, .zodiac-icons-list, .special-icons-wrapper':
        {
            maxHeight: '0px',
            overflow: 'hidden',
            transition: 'max-height 0.3s ease-out, margin-top 0.3s ease-out;'
        },
    '.engraving-first-line-wrapper.show, .engraving-second-line-wrapper.show, .engraving-third-line-wrapper.show, .engraving-fourth-line-wrapper.show, .engraving-fifth-line-wrapper.show, .engraving-fonts.show, .ks-icons-list.show, .zodiac-icons-list.show, .special-icons-wrapper.show':
        {
            maxHeight: '1500px',
            transition: 'max-height 0.3s ease-out, margin-top 0.3s ease-out;'
        },
    '#product__image': {
        marginTop: '15px'
    },
    '.single-face #face-wrapper': {
        display: 'none !important'
    },
    '#modal_product__image > *:not(:first-child)': {
        display: 'none !important'
    },
    '#attn-waitlist-trigger': {
        display: 'block !important',
        width: '100%',
        marginTop: '30px'
    },
    '#attn-waitlist-trigger-btn, #attn-waitlist-trigger button': {
        display: 'inline-flex !important',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100% !important',
        height: '56px !important',
        minHeight: '56px',
        margin: 0,
        padding: '4px 25px',
        border: 'none !important',
        borderRadius: '90px !important',
        backgroundColor: 'gray.450 !important',
        color: 'black.100 !important',
        fontFamily: 'var(--chakra-fonts-inter)',
        fontSize: '17px !important',
        fontWeight: '400 !important',
        lineHeight: '26px !important',
        letterSpacing: '0.085px',
        cursor: 'pointer',
        appearance: 'none',
        WebkitAppearance: 'none',
        transition: 'background-color .15s ease'
    },
    '#attn-waitlist-trigger-btn:hover, #attn-waitlist-trigger button:hover': {
        backgroundColor: 'gray.400 !important',
        color: 'black.100 !important',
        textDecoration: 'none'
    },
    '#attn-waitlist-trigger-btn[data-signup-complete="true"], #attn-waitlist-trigger-btn:disabled':
        {
            backgroundColor: 'gray.40 !important',
            color: 'gray.650 !important',
            cursor: 'default'
        }
}
